import { createContext, useContext } from 'react';
import {
    OnQuerySucceededPayload,
    SettingsState,
    VizSettingsPayload,
    initialSettingsState,
} from 'routes/Explore/hooks/reducers/settingsReducer';
import { ChartSettingsT } from 'business/definitions';

type SettingsDispatchContextT = {
    resetSettings: () => void;
    applyChartSettings: (chartSettings: ChartSettingsT) => void;
    updateVizSettings: (vizSettings: VizSettingsPayload) => void;
    onQuerySucceeded: (payload: OnQuerySucceededPayload) => void;
    setReloadChart: (value: boolean) => void;
};

export const SettingsContext =
    createContext<SettingsState>(initialSettingsState);

export const SettingsDispatchContext = createContext<SettingsDispatchContextT>({
    resetSettings: () => {},
    applyChartSettings: () => {},
    updateVizSettings: () => {},
    onQuerySucceeded: () => {},
    setReloadChart: () => {},
});

export const useSettingsContext = () => useContext(SettingsContext);
export const useSettingsDispatchContext = () =>
    useContext(SettingsDispatchContext);
